/**
 * Extract the native reject code from an Azure speech module rejection.
 *
 * The Swift/Kotlin modules reject with `promise.reject(code, message)`.
 * Depending on the bridge, the code surfaces as `error.code` (classic RN /
 * web codedError) or as `error.name` (Expo Modules wraps rejections in
 * `Exception(name: code, …)`). Callers switch on codes like
 * `no_match_initial_silence_timeout` or `already_recognizing` — this helper
 * hides the bridge difference.
 */
export function nativeErrorCode(error: unknown): string | undefined {
  const e = error as { code?: unknown; name?: unknown } | null;
  if (typeof e?.code === 'string' && e.code.length > 0) return e.code;
  if (typeof e?.name === 'string' && e.name.length > 0 && e.name !== 'Error') {
    return e.name;
  }
  return undefined;
}
